/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CHECK_STATUS: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.checkStatus',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CHECK_STATUS' },
      },
    },
    CHECK_STATUS: {
      invoke: {
        id: 'checkStatus',
        src: 'checkStatus',
        onDone: {
          target: 'CHECK_STATUS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CHECK_STATUS_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CHECK_STATUS_SUCCESS: {
      on: {
        TRIGGER_REFRESH: { target: 'CHECK_STATUS' },
      },
    },
    CHECK_STATUS_FAILED: {
      on: {
        TRIGGER_REFRESH: { target: 'CHECK_STATUS' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
